export default {
      id: "logo-rus-usage",
      viewBox: "0 0 70 16",
      url: __webpack_public_path__ + "sprite.svg#logo-rus",
      toString: function () {
        return this.url;
      }
    }